
import { useTheme } from 'next-themes';
import { usePageTitle } from '@/hooks/usePageTitle';
import { Sun, Moon, Monitor, Check } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { PageHeader } from '@/components/ui/page-header';

const themes = [
  {
    value: 'light',
    label: 'Light',
    description: 'A clean, bright appearance',
    icon: Sun,
  },
  {
    value: 'dark',
    label: 'Dark',
    description: 'Easy on the eyes in low light',
    icon: Moon,
  },
  {
    value: 'system',
    label: 'System',
    description: 'Follows your device settings',
    icon: Monitor,
  },
] as const;

function AppearancePage() {
  usePageTitle('Appearance');
  const { theme, setTheme } = useTheme();

  return (
    <div className="space-y-6">
      <PageHeader
        title="Appearance"
        description="Customize how the app looks and feels"
        askAi
        hideTitleOnMobile={false}
      />

      <div className="grid gap-4 sm:grid-cols-3">
        {themes.map((t) => {
          const isActive = theme === t.value;
          return (
            <button
              key={t.value}
              onClick={() => setTheme(t.value)}
              className="text-left"
            >
              <Card className={`cursor-pointer transition-colors hover:border-primary/50 ${isActive ? 'border-primary border-2' : ''}`}>
                <CardHeader className="pb-3">
                  <div className="flex items-center justify-between">
                    <t.icon className="h-5 w-5 text-muted-foreground" />
                    {isActive && <Check className="h-4 w-4 text-primary" />}
                  </div>
                  <CardTitle className="text-base">{t.label}</CardTitle>
                  <CardDescription>{t.description}</CardDescription>
                </CardHeader>
              </Card>
            </button>
          );
        })}
      </div>
    </div>
  );
}

import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/settings/appearance')({ component: AppearancePage });
